import { apiService } from './apiService';
import { Entitlement, EntitlementId, PutEntitlementDto } from '../types/entitlements';
import { IEmsAuditEvent } from '../types/audit-event';
import { IKeysetPaginationResult } from '../types/search';

class EntitlementsService {
  public async getEntitlements(identityId: string): Promise<Entitlement[]> {
    return apiService.bffClient
      .get<Entitlement[]>(`/identities/${identityId}/entitlements`)
      .then((r) => r.data);
  }

  public async putEntitlement(
    identityId: string,
    entitlementId: EntitlementId,
    body: PutEntitlementDto
  ): Promise<number> {
    return apiService.bffClient
      .put(
        `/identities/${identityId}/entitlements/${entitlementId.process}/${entitlementId.system}/${entitlementId.sourceId}`,
        body
      )
      .then((r) => r.status);
  }

  public async getAuditEvents(
    identityId: string,
    cursor?: string,
    pageSize = 20,
    direction: 'Forward' | 'Backward' = 'Forward'
  ): Promise<IKeysetPaginationResult<IEmsAuditEvent>> {
    return apiService.bffClient
      .get<
        IKeysetPaginationResult<IEmsAuditEvent>
      >(`/identities/${identityId}/entitlements/audit-events`, { params: { cursor, pageSize, direction } })
      .then((r) => r.data);
  }

  public async getDeletedEntitlementEvents(
    identityId: string,
    pageSize = 20,
    cursor?: string,
    direction: 'Forward' | 'Backward' = 'Forward'
  ): Promise<IKeysetPaginationResult<IEmsAuditEvent>> {
    return apiService.bffClient
      .get<IKeysetPaginationResult<IEmsAuditEvent>>(
        `/identities/${identityId}/entitlements/audit-events`,
        {
          params: {
            eventType: 'auditing.event.entitlement.deleted.v1',
            pageSize,
            cursor,
            direction,
          },
        }
      )
      .then((r) => r.data);
  }

  public async getAuditEventsForEntitlement(
    identityId: string,
    process: string,
    system: string,
    sourceId: string,
    pageSize = 20,
    cursor?: string,
    direction: 'Forward' | 'Backward' = 'Forward'
  ): Promise<IKeysetPaginationResult<IEmsAuditEvent>> {
    return apiService.bffClient
      .get<IKeysetPaginationResult<IEmsAuditEvent>>(
        `/identities/${identityId}/entitlements/audit-events`,
        {
          params: {
            process,
            system,
            sourceId,
            pageSize,
            cursor,
            direction,
          },
        }
      )
      .then((r) => r.data);
  }
}

export const entitlementsService = new EntitlementsService();
